import { Review } from "models/schemas";
export { TAB_ID_QUERY_PARAM } from "utils/gaia-constants";
export const APPROVALS_TAB_ID = "approvals";
export const KB_APPROVALS_TAB_ID = "kb-approvals";

export type IReviewsProps = {};

// export interface ReviewsListRequest {
//   teamName: string;
//   reviewer: string;
//   reviewType: string;
// }

export interface ReviewsListRequest {
  teamName: string;
  reviewer: string;
  reviewType: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortOrder?: "ASC" | "DESC";
  filterText?: string;
  additionalFilters?: {
    [key: string]: string;
  };
}

export type MyReviewListItem = Pick<
  Review,
  "dueDate" | "requestedBy" | "status" | "reviewer" | "modifiedAt"
> & {
  auditName: string;
  taskGroupName: string;
  taskName: string;
};

// export interface ReviewsListResponse {
//   reviews: Array<Review>;
// }

export interface ReviewsListResponse {
  reviews: Array<Review>;
  paginationMetadata: {
    totalCount: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
  };
}

export interface ListTeamApprovalRequest {
  teamName: string;
  page: number;
  pageSize: number;
  sortBy?: string;
  sortOrder?: string;
  searchType: string;
  user?: string;
  filterText?: string;
  dueDateStart?: number;
  dueDateEnd?: number;
  createdAtStart?: number;
  createdAtEnd?: number;
  approvedAtStart?: number;
  approvedAtEnd?: number;
  reviewTypes?: string[];
}

export interface ListTeamApprovalResponse {
  approvals: TeamApproval[];
  paginationMetadata: {
    totalCount: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
  };
}

export interface GetApprovalStatRequest {
  teamName: string;
  searchType: string;
  user: string;
}

export interface GetApprovalStatResponse {
  count: number;
}

export interface TeamApproval {
  approvalId: string;
  approvalStatus: string;
  dueDate: number;
  createdAt: number;
  parentId: string;
  parentName: string;
  gaiaObjectId?: string;
  gaiaObjectName?: string;
  taskGroupId?: string;
  taskGroupName?: string;
  requestedBy: string;
  messageFromRequester: string;
  teamName: string;
  endedAt: string;
  reviewId?: string;
  approvedDocCount?: number;
  rejectedDocCount?: number;
}

export enum ApprovalSearchType {
  APPROVER_PENDING_APPROVALS = "APPROVER_PENDING_APPROVALS",
  APPROVER_OVERDUE_APPROVALS = "APPROVER_OVERDUE_APPROVALS",
  APPROVER_PAST_DECISIONS = "APPROVER_PAST_DECISIONS",
  REQUESTER_PENDING_APPROVALS = "REQUESTER_PENDING_APPROVALS",
  REQUESTER_OVERDUE_APPROVALS = "REQUESTER_OVERDUE_APPROVALS",
  REQUESTER_PAST_APPROVALS = "REQUESTER_PAST_APPROVALS",
}

interface DateRangeValidationResult {
  valid: true;
}

interface DateRangeInvalidResult {
  valid: false;
  errorMessage: string;
}

export type DateRangeValidation =
  | DateRangeValidationResult
  | DateRangeInvalidResult;
